/* eslint-disable no-console */
/**
 * Newsletter popup
 * - Time-delayed trigger (configurable via data-delay ms).
 * - Optional exit intent (data-exit-intent="true"): fires when
 *   the cursor leaves the viewport near the top edge.
 * - localStorage throttle: respects "shown" + "dismissed" keys.
 * - Disabled inside Shopify's theme editor.
 * - Minimal focus trap (Tab cycles inside the dialog).
 */
(function () {
  if (typeof document === 'undefined') return;

  function getStorage(key) {
    try { return window.localStorage.getItem(key); } catch (_) { return null; }
  }
  function setStorage(key, val) {
    try { window.localStorage.setItem(key, val); } catch (_) {}
  }

  function inEditor() {
    return !!(window.Shopify && (window.Shopify.designMode || window.Shopify.themeEditor));
  }

  function trapFocus(dialog, e) {
    if (e.key !== 'Tab') return;
    var focusables = dialog.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      last.focus(); e.preventDefault();
    } else if (!e.shiftKey && document.activeElement === last) {
      first.focus(); e.preventDefault();
    }
  }

  function initOne(popup) {
    if (popup.__popupBound) return;
    popup.__popupBound = true;

    var key = popup.getAttribute('data-storage-key') || 'popup_newsletter_v1';
    var delay = parseInt(popup.getAttribute('data-delay') || '4000', 10);
    var exitIntent = popup.getAttribute('data-exit-intent') === 'true';
    var lastShownAt = parseInt(getStorage(key + '_shown_at') || '0', 10);
    var dismissed = getStorage(key + '_dismissed') === '1';
    var throttleDays = parseInt(popup.getAttribute('data-throttle-days') || '7', 10);
    var now = Date.now();
    var elapsedDays = (now - lastShownAt) / 86400000;

    var dialog = popup.querySelector('.popup-newsletter__dialog');
    var closeBtn = popup.querySelector('[data-popup-close]');
    var declineBtn = popup.querySelector('[data-popup-dismiss]');
    var form = popup.querySelector('form');

    function show() {
      if (popup.classList.contains('is-open')) return;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setStorage(key + '_shown_at', String(Date.now()));
      var focusTarget = popup.querySelector('[data-autofocus], input, button');
      if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 60);
    }
    function hide(dismiss) {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (dismiss) setStorage(key + '_dismissed', '1');
    }

    if (inEditor()) return;
    if (dismissed) return;
    if (lastShownAt && elapsedDays < throttleDays && !dismissed) return;

    var fired = false;
    function fire() { if (!fired) { fired = true; show(); } }

    setTimeout(fire, isNaN(delay) ? 4000 : delay);

    if (exitIntent) {
      document.addEventListener('mouseleave', function (e) {
        if (e.clientY <= 4) fire();
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', function () { hide(true); });
    if (declineBtn) declineBtn.addEventListener('click', function () { hide(true); });

    popup.addEventListener('click', function (e) {
      if (e.target.classList && e.target.classList.contains('popup-newsletter__backdrop')) {
        hide(true);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!popup.classList.contains('is-open')) return;
      if (e.key === 'Escape') { hide(true); return; }
      if (dialog) trapFocus(dialog, e);
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = form.querySelector('input[type="email"]');
        if (!email || !email.value) return;

        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'contact' : '/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
          body: new URLSearchParams({
            'form_type': 'customer',
            'utf8': '',
            'contact[email]': email.value,
            'contact[accepts_marketing]': 'true'
          })
        }).then(function (res) {
          if (res.ok || res.status === 0 || res.status === 302) {
            popup.classList.add('popup-newsletter--success');
            setTimeout(function () { hide(false); }, 3200);
          } else {
            email.value = '';
            email.focus();
          }
        }).catch(function () {
          email.value = '';
          email.focus();
        });
      });
    }
  }

  function init() {
    var popups = document.querySelectorAll('[data-popup-newsletter]');
    if (!popups.length) return;
    popups.forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
